import { MsSystem } from "@/types/mssystem";
import { api } from "..";
import { buildQueryString } from "./utils";
import { ResultOk } from "@/types/resultok";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    // 获取消息列表，包含已读消息
    getMsSystem: build.query<MsSystem[], { user_id: string; limit: number }>({
      query: (params) => `/mssystem${buildQueryString(params)}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),

    // 已读消息，点击消息的时候调用
    readMsSystem: build.mutation<ResultOk, { user_id: string; message_id: string }>({
      query: (body) => ({
        url: "/mssystem/read",
        method: "POST",
        body,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
    getMsCount:build.query<number,any>({
      query: () => `/mssystem/count`
    })
  }),
});

export const { useGetMsSystemQuery,useReadMsSystemMutation,useLazyGetMsSystemQuery,useLazyGetMsCountQuery } = userApi;
